<template>
    <div id="history2021715">
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top = "0" id="searchForm_iotDevice">
      <el-col :span="5">
        <el-form-item label="费用种类">
          <el-select
            v-model="query.subjectId"
            placeholder="全部"
            style="width: 100%"
           
          >
             <el-option
                        v-for="item in subjectList"
                        :key="item"
                        :value="item.id"
                        :label="item.name"
                    >
                    </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="缴费来源">
          <el-select v-model="query.payCost" style="width: 100%;" clearable placeholder="全部">
              <el-option
                v-for="item in allPayCostList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
          </el-select>
        </el-form-item>
      </el-col>
     
     <el-col :span="8">
        <el-form-item label="支付时间">
          <el-date-picker
          v-model="payTime"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        </el-form-item>
      </el-col>
      
      <el-col :span="7">
        <el-form-item label="支付方式">
          <el-select v-model="query.payType" placeholder="全部" style="width: 61%;" clearable>
             <el-option
                style="padding-left: 10px;"
                v-for="item in payTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
     <el-col :span="16"  style="display:flex;justify-content: flex-end">
              <el-button icon="el-icon-search" size="small" type="primary" @click="search" :disabled="subjectDisabledFlag">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" size="small" @click="searchReset">
                重置
              </el-button>
      </el-col>
    </el-form>
     
    <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   v-model="form"
                   ref="crud"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                   @refresh-change="onLoad"
        >
        <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-printer"
          v-if="scope.row.feeSortCount !== ''"
          @click="printBill(scope.row)"
          >票据打印
        </el-button>
      </template>
           
    </avue-crud>
      <printPreview ref="printPreview" @saveF5="onLoad"></printPreview>
    </div>
</template>

<script>
  import {
  getBillSearch,getSubjectList
} from '@/api/charge/charge-pay';
import { getDictionaryWithIntKey } from '../../../api/common';
import { getDictionary } from '../../../api/common';
import printPreview from '@/views/v4ward/pay/printdialog-v2/printPreview';
    export default {
      components:{printPreview},
        props:{
            searchItem:{}
        },
         data() {
        return {
            loading: true,
            query: {
            payCost:"",
            payType:'',
            subjectId:'',
            payStartTime:undefined,
            payEndTime:undefined,
            
            },
            payTime:[],
            subjectDisabledFlag:true,
            form:{},
            data:[],
            option:{
                    height: '500',
                    calcHeight: 500,
                    tip: false,
                    border: true,
                    index: true,
                    indexLabel: "序号",
                    viewBtn: false,
                    addBtn:false,
                    selection: false,
                    excelBtn: false,
                    editBtn:false,
                    delBtn:false,
                    menuWidth:120,
                    menuPosition: 'center',
                    align: 'center',
                     column:[
                         {
                                    label: "缴费来源",
                                    prop: "payCost",
                                    type:'select',
                                    dataType:'string',
                                    props:{
                                        label:'dictValue',
                                        value:'dictKey'
                                    },
                                    dicUrl:'/api/blade-system/dict/dictionary?code=pay_cost'
                                   
                        },
                        {
                                    label: "账单周期",
                                    prop: "billcycleNo",
                        },
                         {
                                    label: "费用种类",
                                    prop: "subjectName",
                                   
                        },
                         {
                                    label: "缴费人",
                                    prop: "payManName",
                                   
                        },
                          {
                                    label: "应缴金额",
                                    prop: "totalCalAmount",
                                   
                        },
                        {
                                    label: "优惠金额",
                                    prop: "totalDerateAmount",
                                   
                        },
                        {
                                    label: "实缴金额",
                                    prop: "totalPayAmount",
                                   
                        },
                         {
                                    label: "支付方式",
                                    type:'select',
                                    prop: "payType",
                                    dataType:'number',
                                    props:{
                                        label:'dictValue',
                                        value:'dictKey'
                                    },
                                    dicUrl:'/api/blade-system/dict/dictionary?code=pay_type'
                        },
                         {
                                    label: "支付时间",
                                    prop: "payTime",
                                   
                        },
                        {
                                    label: "操作人",
                                    prop: "cashierName",
                                   
                        },
                        {
                                    label: "票据号",
                                    prop: "invoiceNo",
                                   
                        },
                        {
                                    label: "备注",
                                    prop: "description",
                                   
                        },
                       
                     ]
            },
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            subjectList:[],
            payTypeList:[],
            allPayCostList: [
                
            ],
            billList:[]
        }
      },
     mounted() {
        
         this.initSelectList();
     },
     methods:{
        //表格清空
        restTable(){
          //数据清空
          this.data = []
          //分页清空
          this.page.total = 0  
        },
         subjectDisabled(){
           this.subjectDisabledFlag = true;
         },
         subjectActive(){
           this.subjectDisabledFlag = false;
         },
         //票据打印 未实现
         printBill(row) {
            this.$refs.printPreview.openPayChargePrintPreDialog(row.payNo);
         },
         //重置搜索条件
         searchReset(){
             this.query ={
            payCost:"",
            payType:'',
            subjectId:'',
            payStartTime:'',
            payEndTime:'',
            
            }
            this.payTime=[]
             //房屋信息
            this.query.targetId = this.searchItem.targetId
            //刷新
            this.onLoad();
         },
         search(){
             this.query.targetId = this.searchItem.targetId
            //  console.log("query",this.query)
             this.onLoad();
         },
        initSelectList() {
            getDictionaryWithIntKey('fee_sort').then((data) => {
                this.feeSortList = data.data;
            });
            //付款类型
            getDictionary('pay_type').then((data) => {
                this.payTypeList = data.data;
                this.payTypeList.unshift({dictKey:'',dictValue:'全部'});
            });
            //收费科目
             getSubjectList().then((res)=>{
                this.subjectList = res.data;
                this.subjectList.unshift({id:'',name:'全部'});
                // this.subjectIds = [this.subjectList[0].id];
            })
            //缴费来源
            getDictionary('pay_cost').then((data) => {
                this.allPayCostList = data.data;
                this.allPayCostList.unshift({dictKey:'',dictValue:'全部'});
            });
        },
        currentChange(currentPage) {
                this.page.currentPage = currentPage;
        },
        sizeChange(pageSize) {
            this.page.pageSize = pageSize;
        },
        onLoad(page) {
           if(this.payTime.length>0){
            this.query.payStartTime = this.payTime[0]+''
            this.query.payEndTime = this.payTime[1]+''
          }
            if(!this.subjectDisabledFlag){
            page = page || this.page;
            this.loading = true;
            getBillSearch(
                Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
            ).then(({data}) => {
                this.page.total = data.total;
                // data.records.forEach(ele=>{
                //     ele.payType = String(ele.payType)
                // })
                this.data = data.records;
                this.loading = false;
                // this.selectionClear();
            });
             }else{
            this.loading = false
          }
        }
     }
    }
  </script>
<style>
#history2021715 .el-input__icon{
  line-height: 32px
}
</style>
<style scoped >

</style>